<template>
    <div v-if="userProfile">
        <div class="mb-5 me-5">
            <canvas ref="qrRef"></canvas>
        </div>
    </div>
</template>

<script>
    import QRCode from "qrcode";
    import apiRepository from "@/services/ApiRepository";

    export default {
        name: "UserCodes",
        data() {
            return {
                userProfile: null,
            };
        },
        mounted() {
            this.fetchUserProfile();
        },
        methods: {
            async fetchUserProfile() {
                try {
                    const response = await apiRepository.userDataGet();
                    if (response && response.data && response.data.userProfile) {
                        this.userProfile = response.data.userProfile;
                        await this.$nextTick();
                        this.generateQRCode();
                        this.generateBarcode();
                    }
                } catch (error) {
                    console.error("Error fetching user profile:", error);
                }
            },

            generateQRCode() {
                const p = this.userProfile;
                const nid = this.userProfile.nid.toString().slice(-4);
                const dob = this.userProfile.dob?.replace(/-/g, '');

                const qrData = `
                        Full Name: ${p.firstName} ${p.lastName}
                        Email: ${p.email}
                        Phone: ${p.mobile}
                        DOB: ${dob}
                        NID: ${nid}
                        TIN: ${p.tin || 'N/A'}
                        Nationality: ${p.nationality}
                        Gender: ${p.gender}`.trim();

                QRCode.toCanvas(this.$refs.qrRef, qrData, {
                    width: 130,
                    margin: 1
                }, (err) => {
                    if (err) console.error("QR error:", err);
                });
            },
        }
    };
</script>
